import { Card, Grid, Icon, IconButton, InputLabel, Tooltip } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { verifyVariable } from "utils/Functions";
import { get } from "utils/WebService";
import MarcacaoEspecialCreateEdit from "./MarcacaoEspecialCreateEdit";
import LoteAssociacaoModal from "./LoteAssociacaoModal";

export default function MarcacaoEspecialConsult() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
    });

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [isLoteModal, setIsLoteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [recordsTotal, setRecordsTotal] = useState(0);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoadingTable(true);
        get("/marcacoes").then((res) => {
            setData(res);
            setRecordsTotal(res.length);
            setPages(1);
            setLoadingTable(false);
        }).catch(() => {
            setLoadingTable(false);
        });
    };

    const backFunction = () => {
        fetchData();
        setIsCreateEdit(false);
        setSelectedId(null);
    }

    const getAlvoName = (alvo) => {
        switch(alvo) {
            case 1: return "Ficha (Devedor)";
            case 2: return "Contrato";
            case 3: return "Ambos";
            default: return "Desconhecido";
        }
    }

    const columns = [
        {
            header: "nome",
            accessorKey: "ccNome",
            cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
            isSorted: true
        },
        {
            header: "aplicação",
            accessorKey: "cvAlvo",
            cell: info => <DefaultCell>{getAlvoName(info.getValue())}</DefaultCell>,
            isSorted: true
        },
        {
            header: "ativo",
            accessorKey: "cvAtivo",
            cell: info => <DefaultCell>{info.getValue() ? "Sim" : "Não"}</DefaultCell>,
            isSorted: false
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <MDBox display="flex">
                    <Tooltip title="Editar">
                        <IconButton
                            onClick={() => {
                                const rowId = info.row.original.cvId;
                                setSelectedId(rowId);
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>edit</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Atribuir em Lote">
                        <IconButton
                            onClick={() => {
                                const rowId = info.row.original.cvId;
                                setSelectedId(rowId);
                                setIsLoteModal(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>group_add</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </MDBox>
            ),
            width: "25%"
        },
    ];

    return (
        <Grid container display="flex" justifyContent="center">
            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <MarcacaoEspecialCreateEdit id={selectedId} closeCreateEdit={backFunction} dataOriginal={data.find(d => d.cvId === selectedId)} />
                </Grid>
            }
            {isLoteModal &&
                <LoteAssociacaoModal open={isLoteModal} handleClose={() => setIsLoteModal(false)} marcacaoId={selectedId} marcacaoObj={data.find(d => d.cvId === selectedId)} />
            }
            <Grid item xs={12} md={12} sx={{ display: isCreateEdit ? "none" : "" }}>
                <Card variant="outlined" sx={{ px: 2, py: 1.5, mb: 2, background: darkMode ? "#23233a" : "#fafafa", borderColor: darkMode ? "#333" : "#ddd" }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} display="flex" alignItems="center" justifyContent="space-between" pt={1}>
                            <MDBox>
                                <MDButton size="medium" variant="contained" color="info" onClick={() => { setSelectedId(null); setIsCreateEdit(true); }}>Adicionar</MDButton>
                            </MDBox>
                        </Grid>
                    </Grid>
                </Card>
                <DataTable loading={loadingTable} columnData={columns} data={data} fetchData={fetchData} totalPages={pages} totalRecords={recordsTotal} changeFilter={false} tableState={tableState} />
            </Grid>
        </Grid>
    );
}
